import { CalendarContext } from './calendar-context'
import { CalendarEvent, CalendarLocation, CalendarPartner, CalendarVehicle, Mode, ReservationState } from './calendar-types'
import { useState } from 'react'
import CalendarNewEventDialog from './dialog/calendar-new-event-dialog'
import CalendarManageEventDialog from './dialog/calendar-manage-event-dialog'

export default function CalendarProvider({
  events,
  setEvents,
  mode,
  setMode,
  date,
  setDate,
  calendarIconIsToday = true,
  children,
  locations,
  setLocations,
  partners,
  setPartners,
  vehicles,
  setVehicles,
  reservationStates,
  setReservationStates
}: {
  events: CalendarEvent[]
  setEvents: (events: CalendarEvent[]) => void
  mode: Mode
  setMode: (mode: Mode) => void
  date: Date
  setDate: (date: Date) => void
  locations: CalendarLocation[]
  setLocations: (locations: CalendarLocation[]) => void
  partners: CalendarPartner[]
  setPartners: (partners: CalendarPartner[]) => void
  vehicles: CalendarVehicle[]
  setVehicles: (vehicles: CalendarVehicle[]) => void,
  reservationStates: ReservationState[]
  setReservationStates: (states: ReservationState[]) => void,

  calendarIconIsToday: boolean
  children: React.ReactNode
}) {
  const [newEventDialogOpen, setNewEventDialogOpen] = useState(false)
  const [manageEventDialogOpen, setManageEventDialogOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null)

  return (
    <CalendarContext.Provider
      value={{
        events,
        setEvents,
        mode,
        setMode,
        date,
        setDate,
        calendarIconIsToday,
        newEventDialogOpen,
        setNewEventDialogOpen,
        manageEventDialogOpen,
        setManageEventDialogOpen,
        selectedEvent,
        setSelectedEvent,
        locations,
        setLocations,
        partners,
        setPartners,
        vehicles,
        setVehicles,
        reservationStates,
        setReservationStates
      }}
    >
      <CalendarNewEventDialog />
      <CalendarManageEventDialog />
      {children}
    </CalendarContext.Provider>
  )
}
